import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=ee11dcc6&scoped=true&"
import script from "./ErrorComponent.vue?vue&type=script&lang=ts&"
export * from "./ErrorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=ee11dcc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee11dcc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VRow})
